<template>
  <div class="printManagementDialog">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="800px">
      <div class="dialogContent">
        <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">
          <el-form-item label="发票类型" prop="invoiceType">
            <el-select v-model="form.invoiceType" placeholder="请填写发票类型" @change="updateInvoiceType">
              <el-option label="增值税普通发票" value="NORMAL"></el-option>
              <el-option label="增值税专用发票" value="SPECIAL"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票类型" prop="billType" v-if="form.invoiceType!='SPECIAL'">
            <el-radio-group v-model="form.billType">
              <el-radio
                v-for="(item, index) in processTypeList"
                :key="index"
                :label="item.value"
              >{{item.name}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="开票类型" prop="billType" v-else>
              <el-input
                  v-model="enterPriseBillType"
                  readonly
              ></el-input>
          </el-form-item>
          <el-form-item label="发票抬头" prop="title">
            <el-input
              v-model="form.title"
              placeholder="请填写发票抬头"
            ></el-input>
          </el-form-item>
          <el-form-item label="税号" prop="code" v-if="form.billType!='PERSONAL' || form.invoiceType=='SPECIAL'">
            <el-input
              v-model="form.code"
              placeholder="请填写税号"
            ></el-input>
          </el-form-item>
          <el-form-item label="开户银行" prop="bank" v-if="form.invoiceType=='SPECIAL'">
            <el-input
              v-model="form.bank"
              placeholder="请填写开户银行"
            ></el-input>
          </el-form-item>
          <el-form-item label="银行账号" prop="bankAccount" v-if="form.invoiceType=='SPECIAL'">
            <el-input
              v-model="form.bankAccount"
              placeholder="请填写银行账号"
            ></el-input>
          </el-form-item>
          <el-form-item label="注册地址" prop="address" v-if="form.invoiceType=='SPECIAL'">
            <el-input
              v-model="form.address"
              placeholder="请填写注册地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="注册电话" prop="mobile" v-if="form.invoiceType=='SPECIAL'">
            <el-input
              v-model="form.mobile"
              placeholder="请填写注册电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="收票人手机" prop="payeeTel">
            <el-input
              v-model="form.payeeTel"
              placeholder="请填写收票人手机"
            ></el-input>
          </el-form-item>
          <el-form-item label="收票人邮箱" prop="payeeEmail">
            <el-input
              v-model="form.payeeEmail"
              placeholder="请填写收票人邮箱"
            ></el-input>
          </el-form-item>

          <el-form-item class="submitButtonClass">
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { saveInvoiceInfo,editInvoiceInfo,findInvoiceInfo } from '../../utils/interface';
export default {
  name: "materialManagementDialog",
  data() {
    return {
      dialogVisible: false,
      title: "",
      enterPriseBillType:"企业",
      form: {
        title: "",
        code: "",
        bank: "",
        bankAccount:"",
        mobile:"",
        address:"",
        billType: "",
        invoiceType: "",
        payeeTel:"",
        payeeEmail:"",
      },
      processTypeList: [
        {
          value:"ENTERPRISE",
          name: "企业",
        },
        {
          value:"PERSONAL",
          name: "个人",
        },
      ],
      rules: {
        title: [
            {required: true, message: '请输入发票抬头', trigger: 'blur'}
        ],
        billType: [
          {required: true, message: '请选择开票类型', trigger: 'change'}
        ],
        invoiceType: [
          {required: true, message: '请选择发票类型', trigger: 'change'}
        ],
        code: [
          {required: true, message: '请填写税号', trigger: 'blur'}
        ],
        bank: [
          {required: true, message: '请填写开户行', trigger: 'blur'}
        ],
        bankAccount: [
          {required: true, message: '请填写银行账号', trigger: 'blur'}
        ],
        mobile: [
          {required: true, message: '请填写电话号码', trigger: 'blur'}
        ],
        address: [
          {required: true, message: '请输入单位地址', trigger: 'blur'}
        ],
        payeeTel: [
          {required: true, validator: this.validatorPhone, trigger: 'blur'}
        ],
        payeeEmail: [
          {required: true, validator: this.validatorEmail, trigger: 'blur'}
        ]
      },
      fromSource:'management'
    };
  },
  methods: {
    // 电话号码校验
    validatorPhone(rule, value, callback) {
      if (value === '') {
          callback(new Error('请输入收票人电话'))
      } else if (!/^1\d{10}$/.test(value)) {
          callback(new Error('请输入正确的电话号码'))
      } else {
          callback()
      }
    },
    validatorEmail(rule, value, callback) {
      if (value === '') {
          callback(new Error('请输入收票人邮箱'))
      } else if (!this.validate.isEmail(value)) {
          callback(new Error('请输入正确的邮箱地址'))
      } else {
          callback()
      }
    },
    updateInvoiceType(){
        // 如果是专用则开票默认为企业
        if(this.form.invoiceType=="SPECIAL"){
            this.form.billType = "ENTERPRISE";
        }else{
            this.form.billType = "";
        }
    },
    init(type,uuid,fromSource) {
      this.dialogVisible = true;
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
      }
      this.fromSource = fromSource;
      if (type === "add") {
        this.title = "新增发票";
        this.reset();
      } else {
          this.reset();
        this.title = "修改发票信息";
        findInvoiceInfo({uuid:uuid}).then((res)=>{
            this.form = res;
        });
      }
    },
      reset(){
          this.form.title = "";
          this.form.code="";
          this.form.bank="";
          this.form.bankAccount="";
          this.form.mobile="";
          this.form.address="";
          this.form.billType="";
          this.form.invoiceType="";
          this.form.payeeTel="";
          this.form.payeeEmail="";
      },
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
            console.log(this.form);
            if(this.form.uuid != null){
                editInvoiceInfo(this.form).then((res)=>{
                    this.$message.success('修改成功！');
                    this.dialogVisible = false;
                    this.$parent.invoiceTitleList();
                });
            }else{
                saveInvoiceInfo(this.form).then((res)=>{
                    this.$message.success('保存成功！');
                    this.dialogVisible = false;
                    if(this.fromSource=="management"){
                      this.$parent.invoiceTitleList();
                    }else {
                      this.$parent.getInvoiceList();
                    }
                });
            }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.dialogContent {
  padding: 0 5%;
  /deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
  }
  /deep/.el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 80px;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {
    width: 80px;
    height: 80px;
  }
  .thumbnailClass {
    width: 80px;
    height: 80px;
    margin-right: 20px;
    .avatar {
      width: 80px;
      height: 80px;
      border: 1px dashed #ddd;
      border-radius: 4px;
      line-height: 80px;
      font-size: 24px;
    }
  }
  .endPeriodClass {
    /deep/.el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .submitButtonClass {
    /deep/.el-form-item__content {
      margin-left: 0 !important;
      text-align: center;
      button {
        padding: 0;
        width: 120px;
        height: 35px;
        line-height: 35px;
        border-radius: 6px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/service/invoiceDialog.vue